import styled from "styled-components"

const GalerieTitle = styled.h1`
  color: ${(props) => props.theme.a_color_gradients.a_dark};
`

export { GalerieTitle }
